import moment from 'moment'
import ReactTooltip from 'react-tooltip'

import { CheckIcon } from '../../../../components/ReusableComponents/Icons/Check'
import { CrossIcon } from '../../../../components/ReusableComponents/Icons/Cross'
import { Cell } from '../../../../components/ReusableComponents/Table/index'
import styles from './CheckCell.module.scss'

const GreenCheck = () => <CheckIcon className={styles.greenCheck} />
const GrayCross = () => <CrossIcon className={styles.grayCross} />

const CheckCell = ({ campaign, ...props }) => {
  const getTooltipContent = () => {
    if (!campaign || campaign.isActive) return null
    
    const reason = campaign.disabledReason || 'No reason provided'
    const updatedOn = campaign.updatedOn
      ? moment(campaign.updatedOn).format('MMM DD, YYYY HH:mm')
      : 'Unknown date'
    const updatedBy = campaign.updatedBy || 'Unknown user'
    
    return `Reason: ${reason}\nUpdated: ${updatedOn} by ${updatedBy}`
  }

  const tooltipId = campaign
    ? `health-check-auto-invite-tooltip-${campaign.category || 'default'}-${campaign.subsidiaryId || 'default'}`
    : 'health-check-auto-invite-tooltip-default'

  return (
    <Cell className={styles.checkCell} {...props}>
      {campaign ? (
        <div
          {...(campaign.isActive
            ? {}
            : {
                'data-tip': getTooltipContent(),
                'data-for': tooltipId
              })}
        >
          {campaign.isActive ? <GreenCheck /> : <GrayCross />}
          {campaign.isActive ? null : (
            <ReactTooltip
              id={tooltipId}
              place="top"
              type="dark"
              effect="solid"
              multiline
            />
          )}
        </div>
      ) : (
        <div className={styles.checkCell}>
          <GrayCross />
        </div>
      )}
    </Cell>
  )
}

export default CheckCell
